import graphql__eb2006a2919100619696 from "./__generated__/MarketingEmailList_query.graphql.ts";import * as React from "react"
import {graphql} from "react-relay";
import {useFragment} from "react-relay/hooks";
import Table from "./presentational/table/Table";
import TableHeader from "./presentational/table/TableHeader";
import TableData, {TextAlignment} from "./presentational/table/TableData";
import {useNavigate} from "react-router";
import StatusBadge from "./presentational/StatusBadge";
import {useIntl} from "react-intl";

type Props = {
    queryRef: any
    searchTerm?: string
    onLoadingChange?: (isLoading: boolean) => void
}

const MarketingEmailList: React.FC<Props> = (props) => {
    const intl = useIntl();
    const data = useFragment(
        graphql__eb2006a2919100619696,
        props.queryRef
    );
    const navigate = useNavigate();

    // Filter marketing emails by search term on client side
    const filteredMarketingEmails = data.marketingEmails?.filter(marketingEmail => {
        if (!props.searchTerm) return true;
        const searchLower = props.searchTerm.toLowerCase();
        return marketingEmail.name.toLowerCase().includes(searchLower) ||
               marketingEmail.mailingList?.name.toLowerCase().includes(searchLower) ||
               marketingEmail.emailTemplate?.name.toLowerCase().includes(searchLower);
    }) || [];

    if (filteredMarketingEmails.length === 0) {
        return (
            <div className="px-6 pb-6 text-gray-500 text-center">
                {intl.formatMessage({id: 'view.marketingEmails.noMarketingEmails'})}
            </div>
        );
    }

    const getStatusBadgeStates = () => ({
        green: [intl.formatMessage({id: 'marketingEmail.status.sent'})],
        yellow: [intl.formatMessage({id: 'marketingEmail.status.sending'})],
        red: [intl.formatMessage({id: 'marketingEmail.status.partiallySent'})],
    });

    const formatStatus = (status: string) => {
        switch (status) {
            case 'DRAFT': return intl.formatMessage({id: 'marketingEmail.status.draft'});
            case 'SENDING': return intl.formatMessage({id: 'marketingEmail.status.sending'});
            case 'SENT': return intl.formatMessage({id: 'marketingEmail.status.sent'});
            case 'PARTIALLY_SENT': return intl.formatMessage({id: 'marketingEmail.status.partiallySent'});
            default: return status;
        }
    };

    const formatDate = (dateString: string | null) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString();
    };

    return (
        <div className="flex-1 min-h-0 relative overflow-y-auto" aria-label={intl.formatMessage({id: 'navigation.marketingEmails'})}>
            <Table>
                <thead>
                    <tr>
                        <TableHeader>{intl.formatMessage({id: 'list.marketingEmail.header.status'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.marketingEmail.header.name'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.marketingEmail.header.mailingList'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.marketingEmail.header.template'})}</TableHeader>
                        <TableHeader className="text-right">{intl.formatMessage({id: 'list.marketingEmail.header.recipients'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.marketingEmail.header.sentAt'})}</TableHeader>
                    </tr>
                </thead>
                <tbody>
                    {filteredMarketingEmails.map(
                        (marketingEmail, index) => {
                            return (
                                <tr
                                    key={marketingEmail.id}
                                    className={(index % 2 === 0 ? 'bg-white' : 'bg-gray-50') + ' hover:bg-gray-100 cursor-pointer' + (marketingEmail.archivedAt ? ' opacity-50' : '')}
                                    onClick={() => navigate("/marketing/emails/" + marketingEmail.id)}
                                >
                                    <TableData>
                                        <StatusBadge
                                            value={formatStatus(marketingEmail.status)}
                                            states={getStatusBadgeStates()}
                                        />
                                    </TableData>
                                    <TableData>
                                        <span className="font-medium">{marketingEmail.name}</span>
                                    </TableData>
                                    <TableData>
                                        {marketingEmail.mailingList?.name || '-'}
                                    </TableData>
                                    <TableData>
                                        {marketingEmail.emailTemplate?.name || '-'}
                                    </TableData>
                                    <TableData textAlignment={TextAlignment.Right}>
                                        {marketingEmail.recipientCount}
                                    </TableData>
                                    <TableData>
                                        {formatDate(marketingEmail.sentAt)}
                                    </TableData>
                                </tr>
                            )
                        }
                    )}
                </tbody>
            </Table>
        </div>
    )
}

export default MarketingEmailList;
